import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  Grid,
  FormControl,
  Typography,
  Link,
  Card,
  CardContent,
  Tooltip,
  Autocomplete,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from '@mui/x-date-pickers';
import 'dayjs/locale/pt';
import * as Yup from 'yup';
import DateFnsUtils from '@date-io/date-fns';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import HandleSupplies from './HandleSupplies';

import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import deLocale from 'date-fns/locale/pt-BR';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import { usePondCycle } from 'hooks/usePondCycle';
import { POND_STATUS_CYCLE } from 'utils/consts';
import { labelField } from 'utils';

function Input() {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle,
  );
  const location = useLocation();
  const [initialSupplies, setInitialSupplies] = useState([]);
  const [pondCycles, setPondCycles] = useState([]);
  const [selectedDate, handleDateChange] = useState(new Date());
  const [selectedHour, handleHourChange] = useState(new Date());
  const [openProgress, setOpenProgress] = useState(false);
  const suppliesIsNull = useState(false);
  const dispatch = useDispatch();
  const disable = useSelector((state) => state.disable.disable);
  const notIsFirstAccess = useSelector(
    (state) => state.notIsFirstAccess.notIsFirstAccess,
  );
  const error = Error();
  const success = Success();
  const classes = useStyles();
  const history = useHistory();
  let { id } = useParams();

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      cycle: '',
      description: '',
      put_at: '',
      supplies: [],
    },
    validationSchema: Yup.object({
      cycle: Yup.number().required('Campo Obrigatório'),
      description: Yup.string().max(
        100,
        'Máximo de caracteres ultrapassado (100 caracteres).',
      ),
    }),
    onSubmit: (values) => {
      if (values.supplies.length === 0) {
        suppliesIsNull[1](true);
        return false;
      }
      dispatch(setLoading(true));
      selectedDate.setHours(selectedHour.getHours());
      selectedDate.setMinutes(selectedHour.getMinutes());
      values.put_at = selectedDate.toUTCString();
      values.cycle = selectedPondCycle.id;
      // values.workers = selectedWorkers.name

      request(values);
    },
  });

  const { selectedPondCycle, setSelectedPondCycle, hasError } = usePondCycle({ formik, location, pondCycles });

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);

    formik.setValues(data);

    setInitialSupplies(data.supplies);

    setSelectedPondCycle(data.cycle);
    handleDateChange(new Date(data.put_at));
    handleHourChange(new Date(data.put_at));
  }

  function updateSupplies(supplies) {
    formik.setFieldValue('supplies', supplies);
  }

  useEffect(() => {
    api.get(`/cycles/cycle-code/${selectedCycle.id}`).then((pondCycles_) => {
      setPondCycles(
        pondCycles_.data.filter(
          (pond) => pond.status === POND_STATUS_CYCLE.CULTIVANDO || pond.status === POND_STATUS_CYCLE.PREPARANDO,
        ),
      );
    });
  }, [selectedCycle]);

  useEffect(() => {
    formik.values.cycle = selectedPondCycle?.id;
  }, [selectedPondCycle]);

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      if (id) {
        await api.put(`/inputs/${id}`, { ...data });
      } else {
        await api.post('/inputs', { ...data });
      }
      success();
      history.push('/inputs');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      {' '}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados de Consumo
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Nessa tela você pode adicionar informações dos insumos que foram consumidos durante o dia.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              <h4>Adicionar Consumo</h4>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormGroup>
                    <Autocomplete
                      noOptionsText={(
                        <Typography>
                          Nenhum viveiro configurado para esse ciclo.
                          <Link
                            style={{ marginLeft: '1%', cursor: 'pointer' }}
                            color="primary"
                            onMouseDown={() => {
                              history.push(
                                notIsFirstAccess ? '/first-cycle' : '/cycle',
                              );
                            }}
                          >
                            Configurar agora +
                          </Link>
                        </Typography>
                      )}
                      name="cycle"
                      options={pondCycles}
                      value={selectedPondCycle}
                      getOptionLabel={(options) => options.pond?.description}
                      onChange={(p, v) => {
                        setSelectedPondCycle(v);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={labelField('Viveiro')}
                          variant="outlined"
                          onBlur={formik.handleBlur}
                          error={hasError}
                          helperText={
                            hasError
                          }
                        />
                      )}
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <LocalizationProvider
                      adapterLocale={deLocale}
                      dateAdapter={DateFnsUtils}
                    >
                      <DatePicker
                        InputLabelProps={{
                          style: { pointerEvents: 'auto' },
                        }}
                        fullWidth
                        variant="inline"
                        inputVariant="outlined"
                        invalidDateMessage="Data Inválida"
                        label="Inserido em (data)"
                        format="dd/MM/yyyy"
                        value={selectedDate}
                        onChange={(date) => handleDateChange(date)}
                        // inputFormat="DD/MM/YYYY"
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormGroup>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <LocalizationProvider
                      adapterLocale={deLocale}
                      dateAdapter={DateFnsUtils}
                    >
                      <TimePicker
                        ampm={false}
                        InputLabelProps={{
                          style: { pointerEvents: 'auto' },
                        }}
                        fullWidth
                        variant="inline"
                        inputVariant="outlined"
                        invalidDateMessage="Hora inválida"
                        label="Inserido às (horas)"
                        format="HH:mm"
                        value={selectedHour}
                        onChange={(date) => handleHourChange(date)}
                        // inputFormat="HH:mm"
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormGroup>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormGroup>
                    <FormControl>
                      <h4>Adicionar Insumo</h4>
                      <HandleSupplies
                        supply_id={id}
                        // supplies={suppliesB}
                        // unities={unities}
                        options={formik.values.supplies}
                        callback={updateSupplies}
                        suppliesIsNull={suppliesIsNull}
                      >
                        {' '}
                      </HandleSupplies>
                    </FormControl>
                  </FormGroup>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="description"
                      label={(
                        <div>
                          Descrição (Opcional)
                          {' '}
                          <HtmlTooltip
                            title={(
                              <>
                                Descrição sucinta para identificação do insumo
                              </>
                            )}
                            placement="right"
                            arrow
                          >
                            <HelpIcon color="primary" fontSize="inherit" />
                          </HtmlTooltip>
                        </div>
                      )}
                      variant="outlined"
                      name="description"
                      type="text"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onKeyDown={formik.handleBlur}
                      errorAndHelper="description"
                      error={
                        formik.touched.description && formik.errors.description
                      }
                      helperText={
                        formik.touched.description && formik.errors.description
                      }
                    />
                  </FormGroup>
                </Grid>
                {/* <FormGroup>
                        <Autocomplete
                            noOptionsText="Sem opções"
                            fullWidth
                            multiple
                            id='worker'
                            options={workers}
                            value={selectedWorkers}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.name}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.name}
                                </React.Fragment>
                            )}
                            onChange={(_, v) => {
                                setSelectedWorkers(v)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant='outlined'
                                    label='Funcionários'
                                    placeholder='Funcionários'
                                />
                            )}
                        />
                    </FormGroup> */}
                {/* <FormGroup>
                        <NumberFormat InputLabelProps={{ style: { pointerEvents: "auto" } }}
                            id="leftover"
                            label={
                                <div>
									Sobra de ração
                                </div>
                            }
                            variant="outlined"
                            name="leftover"
                            thousandSeparator='.'
                            decimalSeparator=','
                            decimalScale={2}
                            value={formik.values.leftover}
                            onValueChange={values => { formik.setValues({ ...formik.values, leftover: values.floatValue }) }}
                            onBlur={formik.handleBlur}
                            customInput={TextField}
                            error={!!(formik.touched.leftover && formik.errors.leftover)}
                            helperText={
                                formik.touched.leftover &&
								formik.errors.leftover &&
								formik.errors.leftover
                            }
                        />
                    </FormGroup> */}
              </Grid>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/inputs/"
            routeDelete="/inputs"
            returnRoute="/inputs"
            id={id}
            disable={disable}
            message="A exclusão dessa entrada pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Input;
